var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-3 w-100"},[_c('div',{staticClass:"text-center"},[_c('img',{staticClass:"logo-img",attrs:{"src":"/src/assets/images/Logo-removebg-preview.png","alt":"Logo","id":"logo"}})])])
}]

export { render, staticRenderFns }